<div ng-class="{'ontario-row input-div' : !editApprovedMode}">
  <div ng-class="{'ontario-column ontario-small-12 ontario-large-12' : !editApprovedMode}">
    @if (!editApprovedMode && !soseMode) {
      <div>
        <h3 class="border-bottom">{{'tpApplicationInfoForm.Title' | translate}}</h3>
      </div>
      <div><b>{{'tpApplicationInfoForm.Description' | translate}}</b></div>
      <br>
        <div>{{'General.MandatoryFields' | translate}}</div>
        <br>
        }
        <form [formGroup]="tpApplicationInfoForm">
          @if (soseMode) {
            <div class="row ontario-row">
              <div class="tp-input-row ontario-column ontario-small-12 ontario-medium-6 ontario-large-5">
                <mat-label class="input-label">
                  <span class="required-field">{{'Contact.LastName' | translate}}</span>
                </mat-label>
                <input autocomplete="family-name" type="text" class='input-text' matInput formControlName="lastName" placeholder="{{'Contact.LastNameTooltip' | translate}}" [class.disabled]="tpApplicationInfoForm.controls['lastName'].disabled" />
              </div>
              @if (showErrorsOverride || (tpApplicationInfoForm.controls['lastName'].invalid &&  tpApplicationInfoForm.controls['lastName'].errors &&
                (tpApplicationInfoForm.controls['lastName'].dirty || tpApplicationInfoForm.controls['lastName'].touched))) {
                <div class="form-field-error ontario-column ontario-small-12"
                  >
                  @if (tpApplicationInfoForm.controls['lastName'].hasError('required')) {
                    <mat-error>
                      {{'Validation.LastName.Required' | translate}}
                    </mat-error>
                  }
                  @if (tpApplicationInfoForm.controls['lastName'].hasError('maxlength')) {
                    <mat-error>
                      {{'Validation.LastName.MaxLength' | translate}}
                    </mat-error>
                  }
                </div>
              }
            </div>
            <div class="row ontario-row">
              <div class="tp-input-row ontario-column top-row ontario-small-12 ontario-medium-6 ontario-large-5">
                <mat-label class="input-label"><span class="required-field first-required">{{'Contact.FirstName' | translate}}</span>
              </mat-label>
              <input type="text" class='input-text' matInput formControlName="firstName" [class.disabled]="tpApplicationInfoForm.controls['firstName'].disabled"
                placeholder="{{'Contact.FirstNameTooltip' | translate}}" />
              </div>
              @if (showErrorsOverride || (tpApplicationInfoForm.controls['firstName'].invalid &&  tpApplicationInfoForm.controls['firstName'].errors &&
                (tpApplicationInfoForm.controls['firstName'].dirty || tpApplicationInfoForm.controls['firstName'].touched))) {
                <div class="form-field-error ontario-column ontario-small-12"
                  >
                  @if (tpApplicationInfoForm.controls['firstName'].hasError('required')) {
                    <mat-error>
                      {{'Validation.FirstName.Required' | translate}}
                    </mat-error>
                  }
                  @if (tpApplicationInfoForm.controls['firstName'].hasError('maxlength')) {
                    <mat-error>
                      {{'Validation.FirstName.MaxLength' | translate}}
                    </mat-error>
                  }
                </div>
              }
            </div>
            <div class="row ontario-row">
              <div class="tp-input-row ontario-column top-row ontario-small-12 ontario-medium-6 ontario-large-5">
                <mat-label class="input-label">{{'Contact.MiddleInitial' | translate}}
                </mat-label>
                <input type="text" class='input-text' matInput formControlName="middleInitial"
                  placeholder="{{'Contact.MiddleInitialTooltip' | translate}}" maxlength="256" />
                </div>
                @if (showErrorsOverride || (tpApplicationInfoForm.controls['middleInitial'].invalid &&  tpApplicationInfoForm.controls['middleInitial'].errors &&
                  (tpApplicationInfoForm.controls['middleInitial'].dirty || tpApplicationInfoForm.controls['middleInitial'].touched))) {
                  <div class="form-field-error ontario-column ontario-small-12"
                    >
                  </div>
                }
              </div>
              <div class="row ontario-row">
                <div class="tp-input-row ontario-column top-row ontario-small-12 ontario-medium-6 ontario-large-5">
                  <mat-label class="input-label"><span class="required-field first-required">{{'Contact.Position' | translate}}</span>
                </mat-label>
                <input type="text" class='input-text' matInput formControlName="position"
                  placeholder="{{'Contact.PositionTooltip' | translate}}" maxlength="256" />
                </div>
                @if (showErrorsOverride || (tpApplicationInfoForm.controls['position'].invalid &&  tpApplicationInfoForm.controls['position'].errors &&
                  (tpApplicationInfoForm.controls['position'].dirty || tpApplicationInfoForm.controls['position'].touched))) {
                  <div class="form-field-error ontario-column ontario-small-12"
                    >
                    @if (tpApplicationInfoForm.controls['position'].hasError('required')) {
                      <mat-error>
                        {{'Validation.Position.Required' | translate}}
                      </mat-error>
                    }
                  </div>
                }
              </div>
              <div class="row ontario-row">
                <div class="tp-input-row ontario-column ontario-small-12 ontario-medium-6 ontario-large-5">
                  <mat-label class="input-label">
                    <span class="required-field">
                      <span>{{'Contact.EmailAddress' | translate}}</span>
                    </span>
                  </mat-label>
                  <input type="text" class='input-text' [class.disabled]="tpApplicationInfoForm.controls['emailAddress'].disabled" matInput formControlName="emailAddress"
                    placeholder="{{'Contact.EmailAddressTooltip' | translate}}" />
                  </div>
                  @if (showErrorsOverride || (tpApplicationInfoForm.controls['emailAddress'].invalid &&  tpApplicationInfoForm.controls['emailAddress'].errors &&
                    (tpApplicationInfoForm.controls['emailAddress'].dirty || tpApplicationInfoForm.controls['emailAddress'].touched))) {
                    <div class="form-field-error ontario-column ontario-small-12"
                      >
                      @if (tpApplicationInfoForm.controls['emailAddress'].hasError('pattern')) {
                        <mat-error>
                          {{'Validation.Email.Pattern' | translate}}
                        </mat-error>
                      }
                      @if (tpApplicationInfoForm.controls['emailAddress'].hasError('required')) {
                        <mat-error>
                          {{'Validation.Email.PoliteRequired' | translate}}
                        </mat-error>
                      }
                    </div>
                  }
                </div>
                <div class="row ontario-row">
                  <div class="tp-input-row ontario-column ontario-small-12 ontario-medium-6 ontario-large-5">
                    <mat-label class="input-label"><span class="required-field">{{'Contact.Phone' | translate}}</span>
                  </mat-label>
                  <input type="text" mask="000-000-0000" class='input-text' matInput formControlName="phone"
                    placeholder="{{'Contact.PhoneTooltip' | translate}}" />
                  </div>
                  @if (showErrorsOverride || (tpApplicationInfoForm.controls['phone'].invalid &&  tpApplicationInfoForm.controls['phone'].errors &&
                    (tpApplicationInfoForm.controls['phone'].dirty || tpApplicationInfoForm.controls['phone'].touched))) {
                    <div class="form-field-error ontario-column ontario-small-12"
                      >
                      @if (tpApplicationInfoForm.controls['phone'].hasError('required')) {
                        <mat-error>
                          {{'Validation.Phone.PoliteRequired' | translate}}
                        </mat-error>
                      }
                      @if (tpApplicationInfoForm.controls['phone'].hasError('pattern')) {
                        <mat-error>
                          {{'Validation.Phone.Pattern' | translate}}
                        </mat-error>
                      }
                    </div>
                  }
                </div>
              } @else {
                <div class="row ontario-row">
                  <div class="tp-input-row ontario-column top-row ontario-small-12 ontario-medium-6 ontario-large-5">
                    <mat-label class="input-label"><span class="required-field first-required">{{'Contact.FirstName' | translate}}</span>
                  </mat-label>
                  <input type="text" class='input-text' matInput formControlName="firstName"
                    placeholder="{{'Contact.FirstNameTooltip' | translate}}" />
                  </div>
                  @if (showErrorsOverride || (tpApplicationInfoForm.controls['firstName'].invalid &&  tpApplicationInfoForm.controls['firstName'].errors &&
                    (tpApplicationInfoForm.controls['firstName'].dirty || tpApplicationInfoForm.controls['firstName'].touched))) {
                    <div class="form-field-error ontario-column ontario-small-12"
                      >
                      @if (tpApplicationInfoForm.controls['firstName'].hasError('required')) {
                        <mat-error>
                          {{'Validation.FirstName.Required' | translate}}
                        </mat-error>
                      }
                      @if (tpApplicationInfoForm.controls['firstName'].hasError('maxlength')) {
                        <mat-error>
                          {{'Validation.FirstName.MaxLength' | translate}}
                        </mat-error>
                      }
                    </div>
                  }
                </div>
                <div class="row ontario-row">
                  <div class="tp-input-row ontario-column ontario-small-12 ontario-medium-6 ontario-large-5">
                    <mat-label class="input-label">
                      <span class="required-field">{{'Contact.LastName' | translate}}</span>
                    </mat-label>
                    <input autocomplete="family-name" type="text" class='input-text' matInput formControlName="lastName" placeholder="{{'Contact.LastNameTooltip' | translate}}" />
                  </div>
                  @if (showErrorsOverride || (tpApplicationInfoForm.controls['lastName'].invalid &&  tpApplicationInfoForm.controls['lastName'].errors &&
                    (tpApplicationInfoForm.controls['lastName'].dirty || tpApplicationInfoForm.controls['lastName'].touched))) {
                    <div class="form-field-error ontario-column ontario-small-12"
                      >
                      @if (tpApplicationInfoForm.controls['lastName'].hasError('required')) {
                        <mat-error>
                          {{'Validation.LastName.Required' | translate}}
                        </mat-error>
                      }
                      @if (tpApplicationInfoForm.controls['lastName'].hasError('maxlength')) {
                        <mat-error>
                          {{'Validation.LastName.MaxLength' | translate}}
                        </mat-error>
                      }
                    </div>
                  }
                </div>
                <div class="row ontario-row">
                  <div class="tp-input-row ontario-column ontario-small-12 ontario-medium-6 ontario-large-5">
                    <mat-label class="input-label"><span class="required-field">{{'Contact.Phone' | translate}}</span>
                  </mat-label>
                  <input type="text" mask="000-000-0000" class='input-text' matInput formControlName="phone"
                    placeholder="{{'Contact.PhoneTooltip' | translate}}" />
                  </div>
                  @if (showErrorsOverride || (tpApplicationInfoForm.controls['phone'].invalid &&  tpApplicationInfoForm.controls['phone'].errors &&
                    (tpApplicationInfoForm.controls['phone'].dirty || tpApplicationInfoForm.controls['phone'].touched))) {
                    <div class="form-field-error ontario-column ontario-small-12"
                      >
                      @if (tpApplicationInfoForm.controls['phone'].hasError('required')) {
                        <mat-error>
                          {{'Validation.Phone.PoliteRequired' | translate}}
                        </mat-error>
                      }
                      @if (tpApplicationInfoForm.controls['phone'].hasError('pattern')) {
                        <mat-error>
                          {{'Validation.Phone.Pattern' | translate}}
                        </mat-error>
                      }
                    </div>
                  }
                </div>
                <div class="row ontario-row">
                  <div class="tp-input-row ontario-column ontario-small-12 ontario-medium-6 ontario-large-5">
                    <mat-label class="input-label">
                      <span class="required-field">
                        <span>{{'Contact.EmailAddress' | translate}}</span>
                      </span>
                    </mat-label>
                    <input type="text" class='input-text' [class.disabled]="tpApplicationInfoForm.controls['emailAddress'].disabled" matInput formControlName="emailAddress"
                      placeholder="{{'Contact.EmailAddressTooltip' | translate}}" />
                    </div>
                    @if (showErrorsOverride || (tpApplicationInfoForm.controls['emailAddress'].invalid &&  tpApplicationInfoForm.controls['emailAddress'].errors &&
                      (tpApplicationInfoForm.controls['emailAddress'].dirty || tpApplicationInfoForm.controls['emailAddress'].touched))) {
                      <div class="form-field-error ontario-column ontario-small-12"
                        >
                        @if (tpApplicationInfoForm.controls['emailAddress'].hasError('pattern')) {
                          <mat-error>
                            {{'Validation.Email.Pattern' | translate}}
                          </mat-error>
                        }
                        @if (tpApplicationInfoForm.controls['emailAddress'].hasError('required')) {
                          <mat-error>
                            {{'Validation.Email.PoliteRequired' | translate}}
                          </mat-error>
                        }
                      </div>
                    }
                  </div>
                }
                @if (!soseMode) {
                  <div class="row ontario-row">
                    <div class="tp-input-row ontario-column ontario-small-12 ontario-medium-6 ontario-large-5">
                      <mat-label class="input-label">
                        <span>{{'Contact.AlternateEmailAddress' | translate}}</span>
                        <app-tooltip [tooltipText]="'tpApplicationInfoForm.EmailNotificationsWillBeSent' | translate">
                        </app-tooltip>
                      </mat-label>
                      <input type="text" class='input-text' matInput formControlName="alternateEmailAddress"
                        placeholder="{{'Contact.AlternateEmailAddressPlaceHolder' | translate}}" />
                        <div class="notes">{{'tpApplicationInfoForm.SeparateEmailsWithComma' | translate}}</div>
                      </div>
                      @if (showErrorsOverride || (tpApplicationInfoForm.controls['alternateEmailAddress'].invalid &&  tpApplicationInfoForm.controls['alternateEmailAddress'].errors &&
                        (tpApplicationInfoForm.controls['alternateEmailAddress'].dirty || tpApplicationInfoForm.controls['alternateEmailAddress'].touched))) {
                        <div class="form-field-error ontario-column ontario-small-12"
                          >
                          @if (tpApplicationInfoForm.controls['alternateEmailAddress'].hasError('pattern')) {
                            <mat-error>
                              {{'Validation.Email.Pattern' | translate}}
                            </mat-error>
                          }
                        </div>
                      }
                    </div>
                  }
                  @if (!soseMode) {
                    <div class="row flex-row ontario-row">
                      <div class="tp-input-row ontario-column ontario-small-12 ontario-medium-6 ontario-large-5 dropdown-col required-col">
                        <app-dropdown [label]="'Contact.RoleInOrganization' | translate"
                          [placeholder]="'Contact.SelectAnAccountType' | translate" [currentLang]="currentLang"
                          [disabled]="tpApplicationInfoForm.controls['role'].disabled"
                          [options]="roleInOrganizationOptions" [(formValue)]="role"
                          (formValueChange)="tpApplicationInfoForm.controls['role'].setValue(role)">
                        </app-dropdown>
                        @if (showErrorsOverride || (tpApplicationInfoForm.controls['role'].invalid &&  tpApplicationInfoForm.controls['role'].errors &&
                          (tpApplicationInfoForm.controls['role'].dirty || tpApplicationInfoForm.controls['role'].touched))) {
                          <div class="form-field-error ontario-column ontario-small-12"
                            >
                            @if (tpApplicationInfoForm.controls['role'].hasError('required')) {
                              <mat-error>
                                {{'Validation.Role.ACRequired' | translate}}
                              </mat-error>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }

                  @if (!soseMode) {
                    <div class="row ontario-row">
                      <div class="ontario-small-12 ontario-medium-6 ontario-column ontario-large-5 heading">
                        <label>{{'Address.MailingAddress' | translate}}</label>
                      </div>
                    </div>
                  }

                  @if (!soseMode) {
                    <div class="row ontario-row">
                      <div class="tp-input-row ontario-column ontario-small-12 ontario-medium-6 ontario-large-5">
                        <app-predictive-address-search [formGroupName]="'AddressForm'" (addressChanged)="addressChanged($event)">
                        </app-predictive-address-search>
                        @if (showErrorsOverride || (tpApplicationInfoForm.get('AddressForm')!.invalid &&  tpApplicationInfoForm.get('AddressForm')!.errors && (tpApplicationInfoForm.get('AddressForm')!.dirty || tpApplicationInfoForm.get('AddressForm')!.touched))) {
                          <div class=" margin-top ontario-small-12"
                            >
                            @if (tpApplicationInfoForm.get('AddressForm')!.invalid) {
                              <mat-error>
                                {{'Validation.StreetAddress.Required' | translate}}
                              </mat-error>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }

                  @if (!soseMode) {
                    <div class="row ontario-row">
                      <div class="tp-input-row ontario-column ontario-small-12 ontario-medium-6 ontario-large-5">
                        <mat-label class="input-label"><span>{{'Address.POBox' |
                        translate}}</span>
                      </mat-label>
                      <input type="text" class='input-text' matInput formControlName="poBox"
                        placeholder="{{'Address.POBoxPlaceHolder' | translate}}" />
                      </div>
                    </div>
                  }
                </form>
              </div>
            </div>
